import { Container, Graphics, Text } from 'pixi.js';

const FONT_FAMILY = 'system-ui, -apple-system, sans-serif';

/**
 * Pill-shaped accent-coloured button used in the slot scene's secondary
 * actions (GAMBLE, COLLECT). The accent colour doubles as the stroke + label
 * fill so each button reads as its own "kind" against the dark background.
 *
 * <p>Distinct from the primary SPIN button which uses a filled-pink fill +
 * white label and has its own hover-pulse logic.
 */
export class ActionButton extends Container {
  private readonly bg: Graphics;
  private readonly text: Text;

  constructor(label: string, accent: number, onTap: () => void) {
    super();
    this.eventMode = 'static';
    this.cursor = 'pointer';

    this.bg = new Graphics();
    this.bg
      .roundRect(-90, -24, 180, 48, 24)
      .fill({ color: 0x1a0830, alpha: 0.95 })
      .stroke({ color: accent, alpha: 0.95, width: 2 });
    this.addChild(this.bg);

    this.text = new Text({
      text: label,
      style: {
        fontFamily: FONT_FAMILY,
        fontSize: 18,
        fontWeight: '900',
        fill: accent,
        letterSpacing: 2,
      },
    });
    this.text.anchor.set(0.5);
    this.addChild(this.text);

    this.on('pointertap', onTap);
  }

  setLabel(label: string): void {
    this.text.text = label;
  }
}
